/**
 * Study decks load Chart.js from a CDN in `StudyPresentationShell` after mount.
 * Chart components read this context so their `$effect` re-runs when `ready` flips,
 * avoiding a race where effects run before `window.Chart` exists (common on slower networks).
 */
export const STUDY_CHART_JS_GATE = Symbol.for('imx.study.chartJsGate')

export type StudyChartJsGate = { ready: boolean }
